import Layout from '@/layout/index.vue'
import { CreateUpdatePartenerEnum } from '@/features/partners/_consts'

export const PartnerRoute = {
  path: '/partners',
  component: Layout,
  redirect: '/partners',
  children: [
    {
      path: '',
      component: (): Promise<any> => import(/* webpackChunkName: "partners" */ '@/features/partners/views/index.vue'),
      name: 'PartnersIndexRoute',
      meta: {
        title: 'PartnersGridRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'create',
      component: (): Promise<any> => import(/* webpackChunkName: "partners" */ '@/features/partners/views/create-update-partener.vue'),
      name: 'PartnersCreateRoute',
      meta: {
        title: 'PartnersCreateRouteTitle',
        requiresAuth: true,
        action: CreateUpdatePartenerEnum.create
      }
    },
    {
      path: 'details/:partnerId',
      component: (): Promise<any> => import(/* webpackChunkName: "partners" */ '@/features/partners/views/details.vue'),
      name: 'PartnersDetailsRoute',
      meta: {
        title: 'PartnersDetailsRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'ignored-documents/:partnerId',
      name: 'PartnerIgnoredDocumentsRoute',
      component: (): Promise<any> => import(/* webpackChunkName: "partners" */ '@/features/partners/views/ignored-documents.vue'),
      meta: {
        title: 'PartnerIgnoredDocumentsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
